/*
 * Futsides · "Crea tu once" en la portada (inspirado en el Build your XI de Icons)
 *
 * El cliente toca cada posición del campo y elige al jugador, que aparece con
 * la camiseta del equipo en el que lo tenemos. Con los 11 elegidos, "Termina tu
 * diseño" le lleva al personalizador con el once ya puesto (mismo formato que
 * un equipo guardado), donde cambia lo que quiera y lo compra.
 *
 * Marcado: <div id="fs-crea-once" data-editor-url="/products/crea-tu-11?view=edicion-de-producto"></div>
 * Necesita: futsides-camiseta-mini.js y window.FS_JUGADORES_URL.
 */
(function () {
  "use strict";
  var raiz = document.getElementById("fs-crea-once");
  if (!raiz || raiz.__fsMontado) return;
  raiz.__fsMontado = true;

  var M = window.FutsidesCamisetaMini;
  var esc = M.esc;
  var GUARDADO = "fs_crea_once_v1";
  var NOMBRES_LINEA = { POR: "Portero", DEF: "Defensa", MED: "Centrocampista", DEL: "Delantero" };
  var PLURAL_LINEA = { POR: "Porteros", DEF: "Defensas", MED: "Centrocampistas", DEL: "Delanteros" };
  // Todas las formaciones de la app: primero las más conocidas y después el resto,
  // agrupadas por defensas (4, 3 y 5)
  var PRIMERAS = ["4-3-3", "4-4-2", "4-2-3-1 ABIERTO", "3-5-2", "3-4-3"];
  var DEFENSAS_ORDEN = { "4": 1, "3": 2, "5": 3 };
  function ordenFormaciones() {
    var resto = Object.keys(cat.formaciones).filter(function (f) { return PRIMERAS.indexOf(f) < 0; }).sort(function (a, b) {
      return ((DEFENSAS_ORDEN[a[0]] || 9) - (DEFENSAS_ORDEN[b[0]] || 9)) || a.localeCompare(b, "es", { numeric: true });
    });
    return PRIMERAS.filter(function (f) { return cat.formaciones[f]; }).concat(resto);
  }

  var cat = null;
  var estado = { formacion: "4-3-3", titulo: "MI ONCE DE LEYENDA", huecos: [] }; // huecos[i] = clave o null
  var porClave = {};

  // Línea de cada puesto según el nombre de la formación ("4-2-3-1" = 4 DEF, 5 MED, 1 DEL):
  // los más retrasados son defensas y los más adelantados delanteros. El 10 es el portero.
  var lineasCache = {};
  function lineas(f) {
    if (lineasCache[f]) return lineasCache[f];
    var pos = cat.formaciones[f] || [], nums = (f.match(/^[\d-]+/) || ["4-3-3"])[0].split("-").filter(Boolean).map(Number);
    var def = nums[0], del = nums[nums.length - 1], r = [];
    var campo = pos.map(function (p, i) { return i; }).filter(function (i) { return i !== 10; })
      .sort(function (a, b) { return pos[b].y - pos[a].y; });
    campo.forEach(function (i, k) { r[i] = k < def ? "DEF" : k >= campo.length - del ? "DEL" : "MED"; });
    r[10] = "POR";
    return (lineasCache[f] = r);
  }
  function linea(i) { return lineas(estado.formacion)[i] || "MED"; }
  function posiciones() { return cat.formaciones[estado.formacion] || cat.formaciones["4-3-3"]; }
  function jugadorEn(i) { return estado.huecos[i] ? porClave[estado.huecos[i]] : null; }
  function elegidos() { return estado.huecos.filter(Boolean).length; }

  function guardar() {
    try { localStorage.setItem(GUARDADO, JSON.stringify(estado)); } catch (e) {}
  }
  function recuperar() {
    try {
      var g = JSON.parse(localStorage.getItem(GUARDADO) || "null");
      if (g && cat.formaciones[g.formacion]) {
        estado.formacion = g.formacion;
        estado.titulo = g.titulo || estado.titulo;
        estado.huecos = (g.huecos || []).map(function (c) { return c && porClave[c] ? c : null; });
      }
    } catch (e) {}
    while (estado.huecos.length < 11) estado.huecos.push(null);
  }

  // ── Estructura ──────────────────────────────────────────────────────────────
  raiz.innerHTML =
    '<div class="fsco">' +
      '<div class="fsco-cab">' +
        '<p class="fsco-kicker">Crea tu once</p>' +
        '<h2 class="fsco-titulo">Tu once de leyenda, <span>cada uno con su camiseta</span></h2>' +
        '<p class="fsco-sub">Toca cada posición del campo y elige al jugador. Cuando tengas los 11, lo terminas en el personalizador y lo pides como póster.</p>' +
      "</div>" +
      '<div class="fsco-cuerpo">' +
        '<div class="fsco-izq">' +
          '<div class="fsco-forms-wrap">' +
            '<button type="button" class="fsco-forms-prev" aria-label="Formaciones anteriores" hidden>&#8249;</button>' +
            '<div class="fsco-forms" role="group" aria-label="Formación"></div>' +
            '<button type="button" class="fsco-forms-next" aria-label="Más formaciones" hidden>&#8250;</button>' +
          '</div>' +
          '<div class="fsco-campo" aria-label="Campo">' +
            '<svg class="fsco-lineas" viewBox="0 0 300 400" preserveAspectRatio="none" aria-hidden="true">' +
              '<rect x="8" y="8" width="284" height="384" rx="2"/><line x1="8" y1="200" x2="292" y2="200"/>' +
              '<circle cx="150" cy="200" r="40"/><circle cx="150" cy="200" r="2.5" class="fsco-punto"/>' +
              '<rect x="70" y="8" width="160" height="62"/><rect x="112" y="8" width="76" height="22"/>' +
              '<rect x="70" y="330" width="160" height="62"/><rect x="112" y="370" width="76" height="22"/>' +
            "</svg>" +
            '<div class="fsco-huecos"></div>' +
          "</div>" +
        "</div>" +
        '<aside class="fsco-panel">' +
          '<p class="fsco-cuenta"><b>0</b> / 11 jugadores elegidos</p>' +
          '<label class="fsco-label" for="fsco-nombre">Nombre de tu equipo</label>' +
          '<input id="fsco-nombre" class="fsco-input" maxlength="26" autocomplete="off">' +
          '<ol class="fsco-once"></ol>' +
          '<button type="button" class="fsco-azar">Completar con jugadores al azar</button>' +
          '<button type="button" class="fsco-cta" disabled></button>' +
          '<p class="fsco-nota">En el personalizador puedes cambiar el campo, los colores y cualquier nombre antes de comprarlo.</p>' +
          '<button type="button" class="fsco-vaciar">Empezar de cero</button>' +
        "</aside>" +
      "</div>" +
      '<div class="fsco-picker" hidden>' +
        '<div class="fsco-picker-fondo" data-cerrar></div>' +
        '<div class="fsco-picker-caja" role="dialog" aria-modal="true" aria-labelledby="fsco-picker-titulo">' +
          '<div class="fsco-picker-cab"><h3 id="fsco-picker-titulo"></h3>' +
            '<button type="button" class="fsco-cerrar" data-cerrar aria-label="Cerrar">&times;</button></div>' +
          '<input type="search" class="fsco-input fsco-buscar" placeholder="Busca un jugador o un equipo" aria-label="Buscar jugador o equipo" autocomplete="off">' +
          '<div class="fsco-tabs" role="tablist"></div>' +
          '<div class="fsco-lista" role="list"></div>' +
        "</div>" +
      "</div>" +
    "</div>";

  var $ = function (s) { return raiz.querySelector(s); };
  var elHuecos = $(".fsco-huecos"), elOnce = $(".fsco-once"), elForms = $(".fsco-forms");
  var elNombre = $("#fsco-nombre"), elCta = $(".fsco-cta"), elCuenta = $(".fsco-cuenta b");
  var picker = $(".fsco-picker"), elLista = $(".fsco-lista"), elBuscar = $(".fsco-buscar"), elTabs = $(".fsco-tabs");

  // ── Pintado ─────────────────────────────────────────────────────────────────
  function pintarFormaciones() {
    elForms.innerHTML = "";
    var activo = null;
    ordenFormaciones().forEach(function (f) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fsco-chip" + (f === estado.formacion ? " activo" : "");
      b.setAttribute("aria-pressed", f === estado.formacion);
      b.textContent = f.toUpperCase();
      b.addEventListener("click", function () { var x = elForms.scrollLeft; estado.formacion = f; guardar(); pintarTodo(); elForms.scrollLeft = x; centrarActivo(); });
      if (f === estado.formacion) activo = b;
      elForms.appendChild(b);
    });
    flechas();
    return activo;
  }
  // La fila de formaciones se desliza en horizontal; las flechas solo salen si hay más a ese lado
  function flechas() {
    var max = elForms.scrollWidth - elForms.clientWidth - 2;
    var prev = elForms.scrollLeft > 2, next = elForms.scrollLeft < max, w = elForms.parentNode;
    $(".fsco-forms-prev").hidden = !prev;
    $(".fsco-forms-next").hidden = !next;
    w.classList.toggle("hay-prev", prev);
    w.classList.toggle("hay-next", next);
  }
  function centrarActivo(alCargar) {
    var a = elForms.querySelector(".activo");
    if (!a) return;
    var x = a.offsetLeft - (elForms.clientWidth - a.offsetWidth) / 2;
    elForms.scrollTo({ left: Math.max(0, x), behavior: alCargar ? "auto" : "smooth" });
  }

  function pintarCampo() {
    elHuecos.innerHTML = "";
    posiciones().forEach(function (p, i) {
      var o = jugadorEn(i), l = linea(i);
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fsco-hueco" + (o ? " lleno" : "");
      b.style.left = (p.x * 100) + "%";
      b.style.top = (p.y * 100) + "%";
      b.setAttribute("aria-label", o ? NOMBRES_LINEA[l] + ": " + o.nombre + ". Cambiar" : "Elegir " + NOMBRES_LINEA[l].toLowerCase());
      if (o) {
        b.innerHTML = '<span class="fsco-cam"></span>';
        M.pintar(b.querySelector(".fsco-cam"), o, o.kit, 78);
      } else {
        b.innerHTML = '<span class="fsco-vacio"><span>+</span></span><span class="fsco-hueco-l">' + l + "</span>";
      }
      b.addEventListener("click", function () { abrirPicker(i); });
      elHuecos.appendChild(b);
    });
  }

  function pintarPanel() {
    var n = elegidos();
    elCuenta.textContent = n;
    elOnce.innerHTML = "";
    posiciones().forEach(function (p, i) {
      var o = jugadorEn(i), l = linea(i);
      var li = document.createElement("li");
      li.innerHTML = '<span class="fsco-once-l">' + l + "</span>" +
        (o ? '<span class="fsco-once-n">' + esc(o.nombre) + ' <small>' + esc(o.equipo) + "</small></span>"
           : '<span class="fsco-once-n fsco-once-vacio">Sin elegir</span>');
      li.addEventListener("click", function () { abrirPicker(i); });
      elOnce.appendChild(li);
    });
    elCta.disabled = n < 11;
    elCta.textContent = n < 11 ? (11 - n === 1 ? "Te falta 1 jugador" : "Te faltan " + (11 - n) + " jugadores") : "Termina tu diseño";
    $(".fsco-azar").hidden = n === 11;
  }

  function pintarTodo() { pintarFormaciones(); pintarCampo(); pintarPanel(); }

  // ── Selector de jugador ─────────────────────────────────────────────────────
  var hueco = null, filtro = null, ultimoFoco = null;

  function abrirPicker(i) {
    hueco = i;
    var l = linea(i, posiciones()[i]);
    filtro = l;
    $("#fsco-picker-titulo").innerHTML = "Elige <span>" + NOMBRES_LINEA[l].toLowerCase() + "</span>";
    elTabs.innerHTML = "";
    [[l, PLURAL_LINEA[l]], [null, "Todos"]].forEach(function (t) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fsco-tab" + (t[0] === filtro ? " activo" : "");
      b.setAttribute("role", "tab");
      b.textContent = t[1];
      b.addEventListener("click", function () {
        filtro = t[0];
        elTabs.querySelectorAll(".fsco-tab").forEach(function (x) { x.classList.toggle("activo", x === b); });
        pintarLista();
      });
      elTabs.appendChild(b);
    });
    elBuscar.value = "";
    ultimoFoco = document.activeElement;
    picker.hidden = false;
    document.documentElement.classList.add("fsco-bloqueo");
    pintarLista();
    setTimeout(function () { elBuscar.focus(); }, 30);
  }
  function cerrarPicker() {
    picker.hidden = true;
    document.documentElement.classList.remove("fsco-bloqueo");
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  var MAX = 60;
  function pintarLista(cuantos) {
    cuantos = cuantos || MAX;
    var texto = elBuscar.value;
    // Al buscar por nombre se busca en todas las posiciones
    var res = M.buscar(cat.lista, texto, texto.trim() ? null : filtro);
    var usados = {};
    estado.huecos.forEach(function (c, i) { if (c && i !== hueco && porClave[c]) usados[porClave[c].id] = 1; });
    elLista.innerHTML = "";
    if (!res.length) {
      elLista.innerHTML = '<p class="fsco-lista-vacia">No tenemos a nadie con ese nombre o equipo.</p>';
      return;
    }
    res.slice(0, cuantos).forEach(function (o) {
      var ya = usados[o.id];
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fsco-fila" + (ya ? " usado" : "") + (estado.huecos[hueco] === o.clave ? " actual" : "");
      b.disabled = !!ya;
      b.innerHTML =
        '<span class="fsco-fila-cam"></span>' +
        '<span class="fsco-fila-txt"><b>' + esc(o.nombre) + "</b>" +
          (o.quien ? '<i>' + esc(o.quien) + "</i>" : "") +
          "<small>" + esc(o.equipos.join(" · ")) + "</small></span>" +
        '<span class="fsco-fila-d">' + (ya ? "Ya está en tu once" : "#" + esc(o.dorsal)) + "</span>";
      M.pintarCuandoSeVea(b.querySelector(".fsco-fila-cam"), o, 46);
      b.addEventListener("click", function () { elegir(o); });
      elLista.appendChild(b);
    });
    if (res.length > cuantos) {
      var mas = document.createElement("button");
      mas.type = "button";
      mas.className = "fsco-mas";
      mas.textContent = "Ver más jugadores (" + (res.length - cuantos) + ")";
      mas.addEventListener("click", function () { var s = elLista.scrollTop; pintarLista(cuantos + MAX); elLista.scrollTop = s; });
      elLista.appendChild(mas);
    }
  }

  function elegir(o) {
    estado.huecos[hueco] = o.clave;
    guardar();
    cerrarPicker();
    pintarCampo();
    pintarPanel();
  }

  // ── Completar al azar (por línea, sin repetir persona) ─────────────────────
  function completarAzar() {
    var usados = {};
    estado.huecos.forEach(function (c) { if (c) usados[porClave[c].id] = 1; });
    posiciones().forEach(function (p, i) {
      if (estado.huecos[i]) return;
      var l = linea(i, p);
      // Leyendas: los que están en más de un equipo, de su línea
      var candidatos = cat.lista.filter(function (o) { return o.linea === l && !usados[o.id] && !o.suplente && o.peso > 1; });
      if (!candidatos.length) candidatos = cat.lista.filter(function (o) { return o.linea === l && !usados[o.id] && !o.suplente; });
      if (!candidatos.length) return;
      var o = candidatos[Math.floor(Math.random() * candidatos.length)];
      usados[o.id] = 1;
      estado.huecos[i] = o.clave;
    });
    guardar();
    pintarCampo();
    pintarPanel();
  }

  // ── Ir al personalizador con el once puesto ────────────────────────────────
  function terminar() {
    if (elegidos() < 11) return;
    var d = JSON.parse(JSON.stringify(cat.base));
    var tam = { j: (d.camisetas || {}).tamanoCamiseta, p: (d.camisetaportero || {}).tamanoCamiseta };
    d.formacionActual = estado.formacion;
    // Mismo césped que el campo de la landing
    d.fondo = { tipo: "svg", nombre: "NATURAL", valor: "NATURAL" };
    d.tituloEquipo = d.tituloEquipo || {};
    d.tituloEquipo.texto = (estado.titulo || "MI ONCE DE LEYENDA").trim().toUpperCase();
    // Que el título quepa en el póster: el tamaño base está pensado para ~10 letras
    var tamBase = parseInt(d.tituloEquipo.tamano, 10) || 58, largo = d.tituloEquipo.texto.length;
    if (largo > 10) d.tituloEquipo.tamano = String(Math.max(24, Math.floor(tamBase * 10 / largo)));
    d.formacion = {};
    posiciones().forEach(function (p, i) {
      var o = jugadorEn(i);
      var kit = JSON.parse(JSON.stringify(o.kit));
      var t = i === 10 ? tam.p : tam.j;
      if (t != null) kit.tamanoCamiseta = t;
      d.formacion[String(i)] = { x: p.x * 100, y: p.y * 100, nombre: o.nombre, dorsal: o.dorsal, configIndividual: kit };
    });
    try {
      localStorage.setItem("diseno_preestablecido", JSON.stringify(d));
      localStorage.setItem("diseno_preestablecido_ts", String(Date.now()));
    } catch (e) {
      alert("Tu navegador no deja guardar el diseño. Prueba fuera del modo incógnito.");
      return;
    }
    var url = raiz.getAttribute("data-editor-url") || "/products/crea-tu-11?view=edicion-de-producto";
    // ?fondo= hace que la preselección de campo del producto elija el mismo campo del diseño
    var fondo = d.fondo && (d.fondo.nombre || d.fondo.valor);
    location.href = url + (url.indexOf("?") === -1 ? "?" : "&") + "preset=metafield" + (fondo ? "&fondo=" + encodeURIComponent(fondo) : "");
  }

  // ── Eventos ─────────────────────────────────────────────────────────────────
  picker.addEventListener("click", function (e) { if (e.target.closest("[data-cerrar]")) cerrarPicker(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !picker.hidden) cerrarPicker(); });
  var t = null;
  elBuscar.addEventListener("input", function () { clearTimeout(t); t = setTimeout(function () { pintarLista(); }, 120); });
  elBuscar.addEventListener("keydown", function (e) { if (e.key === "Enter") e.preventDefault(); });
  elNombre.addEventListener("input", function () { estado.titulo = elNombre.value; guardar(); });
  $(".fsco-azar").addEventListener("click", completarAzar);
  $(".fsco-vaciar").addEventListener("click", function () {
    estado.huecos = estado.huecos.map(function () { return null; });
    guardar();
    pintarCampo();
    pintarPanel();
  });
  elCta.addEventListener("click", terminar);
  elForms.addEventListener("scroll", flechas, { passive: true });
  window.addEventListener("resize", flechas);
  $(".fsco-forms-prev").addEventListener("click", function () { elForms.scrollBy({ left: -elForms.clientWidth * 0.7, behavior: "smooth" }); });
  $(".fsco-forms-next").addEventListener("click", function () { elForms.scrollBy({ left: elForms.clientWidth * 0.7, behavior: "smooth" }); });

  // ── Arranque: el catálogo se pide cuando la sección se acerca a pantalla ───
  function arrancar() {
    M.catalogo().then(function (d) {
      cat = d;
      d.lista.forEach(function (o) { o.clave = o.id + "|" + o.nombre + "|" + o.dorsal + "|" + o.equipo; porClave[o.clave] = o; });
      recuperar();
      elNombre.value = estado.titulo;
      pintarTodo();
      raiz.classList.add("fsco-listo");
      centrarActivo(true);
    }).catch(function (e) {
      console.warn("[Futsides] Crea tu once: sin catálogo", e);
      raiz.hidden = true;
    });
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); arrancar(); }
    }, { rootMargin: "600px 0px" });
    io.observe(raiz);
  } else {
    arrancar();
  }
})();
